import getB from '../bridge/EkaBridge';

declare global {
    interface Window {
        mxpDataLayer: any[];
    }
}

export function track(name: string, params?: { [k: string]: string | undefined }): void {
    const formattedEvent = { eventName: name, extraParams: params };

    if (!window.mxpDataLayer) {
        window.mxpDataLayer = [];
    }

    window.mxpDataLayer.push(formattedEvent);
    getB().track(name, params);
}
